module.exports = __webpack_public_path__ + "static/media/aol-explorer.f2a4363b.svg";